"use client";

import { stegaClean } from "next-sanity";
import { AffiliateHeroItemRow } from "@/components/pageComponents/global/AffiliateHeroItems";
import type { IAffiliateHeroRecommendation } from "@/sanity/lib/definitions";

/**
 * The "Exclusive recommendation by <partner>" row under the shared hero list.
 * It names the partner, so it lives on the page (`heroRecommendation`), not in
 * the global. Carries its own divider so it sits in the list like the rows above.
 */
export default function AffiliateHeroRecommendation({ item }: { item?: IAffiliateHeroRecommendation }) {
  if (!item || (!item.icon && !stegaClean(item.text))) return null;

  return (
    <>
      <hr className="w-full border-t border-black/10" />
      <AffiliateHeroItemRow
        icon={item.icon}
        text={item.text}
      />
    </>
  );
}
